import { WidgetRow } from '..'

export const WidgetRowFactory = {
  createEmpty(): WidgetRow {
    return {
      widgets: []
    }
  }
}
